import type { RecordCallUuidInput } from '@infra/controllers/record-call-uuid.controller';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import {
  type BusEvent,
  BusEventsPromisifier,
} from '@main/utils/bus-event-promisifier';
import type { BaseUsecase } from '@usecases/base-usecase';
import { parsePhoneNumberWithError } from 'libphonenumber-js';

export type RecordCallUuidRequest = RecordCallUuidInput;

export type RecordCallUuidUsecase = BaseUsecase<RecordCallUuidRequest, void>;

export class RecordCallUuid implements RecordCallUuidUsecase {
  async run(request: RecordCallUuidRequest): Promise<void> {
    const { phoneNumber, callUuid } = request;
    if (!phoneNumber || !callUuid) {
      return;
    }
    const parsedPhoneNumber =
      parsePhoneNumberWithError(phoneNumber)?.format('E.164');

    const busIframe = await BusIframe.getIframe();

    const payload = {
      externalAccountId: '',
      recordId: callUuid,
      recordType: 'vendorkey',
      actionValue: parsedPhoneNumber,
      action: 'scvTelephony',
    };

    const busEvent: BusEvent = {
      type: 'API.RECORD_ACTION_RESOURCE',
      payload: payload,
    };

    await BusEventsPromisifier.promisifySyncEvent({
      target: busIframe,
      event: busEvent,
      fulfilled: 'API.RECORD_ACTION_RESOURCE_FULFILLED',
      rejected: 'API.RECORD_ACTION_RESOURCE_REJECTED',
    });
  }
}
